import { Grid } from "antd";
import { createContext, PropsWithChildren, useContext } from "react";

type LayoutContextType = {
  getPadding: () => string;
};

const LayoutContext = createContext<LayoutContextType>({
  getPadding: () => "var(--padding-horizontal-xs)",
});

type LayoutContextProviderType = PropsWithChildren & {};

export const LayoutContextProvider = ({
  children,
}: LayoutContextProviderType) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const getPadding = () => {
    if (screens.xxl) return "var(--padding-horizontal-xxl)";
    if (screens.xl) return "var(--padding-horizontal-xl)";
    if (screens.lg) return "var(--padding-horizontal-lg)";
    if (screens.md) return "var(--padding-horizontal-md)";
    if (screens.sm) return "var(--padding-horizontal-sm)";
    return "var(--padding-horizontal-xs)"; // Default for xs or smaller
  };

  return (
    <LayoutContext.Provider value={{ getPadding }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const LoadingValue = useContext(LayoutContext);
  return LoadingValue;
};
